import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { MessageResponse } from '@ujet/websdk-headless';
import styles from './PhotoMessage.module.scss';
import classNames from 'classnames/bind';
import dayjs from 'dayjs';
import { Card, Typography } from 'gd-design-library';

const cx = classNames.bind(styles);

const CN = 'photo-message';
const cardClass = `${CN}__card`;
const imgClass = `${CN}__img`;

interface PhotoMessageProps {
  message: MessageResponse;
  scrollToBottom: () => void;
}

export const PhotoMessage = ({ message, scrollToBottom }: PhotoMessageProps): React.ReactElement => {
  const isEndUser = useMemo(() => message.$userType === 'end_user', [ message ]);

  return typeof message.url === 'string' && (
    <Box className={ cx(CN, { [`${CN}--end-user`]: isEndUser, [`${CN}--agent`]: !isEndUser }) }>
      <Card
        className={ cx(cardClass, { [`${cardClass}--end-user`]: isEndUser, [`${cardClass}--agent`]: !isEndUser }) }
      >
        <img src={ message.url } className={ cx(imgClass) } alt={ message.file?.name } onLoad={ scrollToBottom } />
      </Card>
      <Typography variant='caption' color='textSecondary'>
        {dayjs(message.$timestamp).format('HH:mm A')}
      </Typography>
    </Box>
  );
};
